import { render, staticRenderFns } from "./CardSubheader.vue?vue&type=template&id=4fe9a091&scoped=true&"
import script from "./CardSubheader.vue?vue&type=script&lang=js&"
export * from "./CardSubheader.vue?vue&type=script&lang=js&"
import style0 from "./CardSubheader.vue?vue&type=style&index=0&id=4fe9a091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe9a091",
  null
  
)

export default component.exports